import { ContactPageSharp } from "@mui/icons-material";

export const toggleScroll = () => {
  const overlays = document.querySelectorAll('.overlay');

  if (overlays.length > 0) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }
};

export const convertImgToBase64 = (inputFile) => {
  if (inputFile === undefined) return '';
  const file = new FileReader();

  return new Promise((resolve, reject) => {
    file.onerror = () => {
      file.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    file.onload = () => {
      resolve(file.result);
    };
    file.readAsDataURL(inputFile);
  });
};


export function formatTextareaContent(report){
  return report
    .replace(/\*\*(.*?)\*\*/g, (_, bold) => bold.toUpperCase()) // optional: uppercase bold
    .replace(/\n{2,}/g, '\n\n') // normalize spacing
    .trim();
}

export function DisplayContent({ htmlContent }) {
  console.log("Rendering HTML Content:", htmlContent); // Debug log
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

export function calculateAge(dob) {
  const birthDate = new Date(dob);
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();

  // Adjust if birthday hasn't occurred yet this year
  if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
      years--;
      months += 12;
  }

  return `${years} year${years !== 1 ? 's' : ''}`;

}

export const months = 
 
    [
      {
        value:0,
        label:"January"
      },
      {
        value:1,
        label:"February"
      },
      {
        value:2,
        label:"March"
      },
      {
        value:3,
        label:"April"
      },
      {
        value:4,
        label:"May"
      },
      {
        value:5,
        label:"June"
      },
      {
        value:6,
        label:"July"
      },
      {
        value:7,
        label:"August"
      },
      {
        value:8,
        label:"September"
      },
      {
        value:9,
        label:"October"
      },
      {
        value:10,
        label:"November"
      },
      {
        value:11,
        label:"December"
      },
      
    ]

export const years = [
  {
    value: 2023,
    label: "2023"
  }
]

export const numberWithCommas = (x) => {
  if (String(x).includes(',')) {
    return String(x).replace(/,/g, '')?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  else {
    return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}

export  const stripCommas = (val) => {
  let num = String(val).replace(/,/g, '')
  return parseFloat(num);
}

export const formatFileUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/${path}`;

export const getStatus = (data) => {
  if (data.statusDetails === "Unasigned") {
      return "Saved"
  }
  if (data.statusDetails === "Pending") {
      return `Currently with ${data.lastApprover} - (${data.pendingOffice})`
  }
  if (data.statusDetails === "ApprovalCompleted") {
      return `Approved by ${data.lastApprover}`
  }
  if (data.statusDetails === "Declined") {
      return `Declined by ${data.lastApprover}`
  }
  return ""
}

export function timeAgo(dateTime) {
  const now = new Date();
  const diffInSeconds = Math.floor((now - dateTime) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 3600) {
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 86400) {
    const diffInHours = Math.floor(diffInSeconds / 3600);
    return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  } else {
    const diffInDays = Math.floor(diffInSeconds / 86400);
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  }
}

export const formatDate = (timestamp) => {
  if (!timestamp) {
    return;
  }
  const dateObject = new Date(timestamp);
  const formattedDate = dateObject.toISOString().split("T")[0];
  return formattedDate;
};

export const gender = [
  { value: "choose", name: "Choose Gender" },
  { value: "Male", name: "Male" },
  { value: "Female", name: "Female" }
];

export  const checkIfAppointmentPassed = (appointmentId , Appointments) => {
  const selectedAppointment = Appointments?.find(
    (item) => item.value === parseFloat(appointmentId)
  );

  if (!selectedAppointment || !selectedAppointment.name) return;
  const appointmentDateString = selectedAppointment.name.split(" at ")[0];
  const appointmentTimeString = selectedAppointment.name.split(" at ")[1].split(" with ")[0];

  // Combine date and time into a single string
  const appointmentDateTimeString = `${appointmentDateString} ${appointmentTimeString}`;

  // Parse the combined string into a Date object
  const appointmentDateTime = new Date(appointmentDateTimeString);

  // Add 30 minutes to the appointment time
  const updatedAppointmentTime = new Date(appointmentDateTime.getTime() + 30 * 60000);

  // Get the current time
  const currentDateTime = new Date();

  // Check if the current time is past the updated appointment time (+30 mins)
  if (currentDateTime > updatedAppointmentTime) {
    return true; // Appointment has passed, including the 30-minute buffer
  }

  return false; 
};

export function formatSavedTable(htmlString = "") {
  if (!htmlString) return htmlString;

  // run only in browser environments
  if (typeof DOMParser === "undefined") return htmlString;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const tables = Array.from(doc.querySelectorAll("table"));

  if (!tables.length) return htmlString;

  const normalizeText = (s = "") => s.replace(/\u00A0/g, " ").trim();

  tables.forEach((table) => {
    // inline table styles
    table.style.width = table.style.width || "100%";
    table.style.borderCollapse = "collapse";
    table.style.border = table.style.border || "1px solid #ddd";
    table.style.fontSize = table.style.fontSize || "14px";

    // style all cells
    const rows = Array.from(table.rows);
    rows.forEach((row) => {
      Array.from(row.cells).forEach((cell) => {
        cell.style.border = cell.style.border || "1px solid #e0e0e0";
        cell.style.padding = cell.style.padding || "6px 8px";
        cell.style.verticalAlign = cell.style.verticalAlign || "top";
        cell.style.lineHeight = cell.style.lineHeight || "1.25";
        // normalize common artifacts
        cell.innerHTML = cell.innerHTML.replace(/<br\s*\/?>/gi, "<br/>").replace(/&nbsp;/g, " ");
      });
    });

    // if there is no THEAD and first row looks like a header, promote it
    if (!table.querySelector("thead") && rows.length > 0) {
      const firstRow = rows[0];
      const cells = Array.from(firstRow.cells);
      // consider a header row when not mostly numeric (e.g. labels like "WIDAL TEST", "Styphi")
      const numericLike = cells.filter((c) => {
        const t = normalizeText(c.textContent || "");
        // match fractions (1/80), numeric or numeric with units like "1/80" "12.5"
        return /^\s*[\d]+([\/\d\.%-]|$)/.test(t);
      }).length;

      if (numericLike < cells.length) {
        const thead = doc.createElement("thead");
        const newTr = doc.createElement("tr");
        cells.forEach((c) => {
          const th = doc.createElement("th");
          th.innerHTML = c.innerHTML;
          th.style.padding = "8px 10px";
          th.style.textAlign = "left";
          th.style.fontWeight = "700";
          th.style.background = "#f7f7f7";
          th.style.border = "1px solid #e0e0e0";
          newTr.appendChild(th);
        });
        thead.appendChild(newTr);

        // remove the original first row and insert thead
        firstRow.parentNode.removeChild(firstRow);
        table.insertBefore(thead, table.firstChild);
      }
    }

    // ensure table has an accessible role
    if (!table.getAttribute("role")) table.setAttribute("role", "table");
  });

  return doc.body.innerHTML;
}